const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');
const {
  flattenCollection
} = require('../lib/common');

/**
  * @function evalute - evaluate flattenCollectionBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const collection = await evaluateSource(source.collection, content, parentContentPath, transientContext, nativeFunctions);
  if (collection === undefined || !isPlainObject(collection)) {
    return undefined;
  }
  return flattenCollection(collection);
};
module.exports = {
  evaluate
};